import { createContext, useContext } from "react";
import useLoading from "../hooks/useLoading";

const LoadingContext = createContext();

export const useLoadingContext = () => useContext(LoadingContext);

/**
 * Provider component for the loading context.
 * @param {object} props - React component props.
 * @param {React.ReactNode} props.children - The child components wrapped by the LoadingProvider.
 * @returns {React.ReactNode} - JSX for the LoadingProvider.
 */

const LoadingProvider = ({ children }) => {
    const loadingContextValue = useLoading();
    return (
        <LoadingContext.Provider value={loadingContextValue}>{children}</LoadingContext.Provider>
    );
};

export default LoadingProvider;
